const isHeaderBlock = (element) => element.matches('ws-block[src*="header"]');

export default isHeaderBlock;
